import type WebSocket from 'ws';
import type { AcpManager } from '../agents/acp/create-acp-manager.js';
import type { PreviewEnvironmentManager } from '../preview-environments/preview-environment-manager.js';
import type { CliE2eeRuntime } from '../lib/e2ee/index.js';
import type { LogFn } from '../log.js';
import type { MessageHandlerDeps } from '../routing/message-handler-deps.js';
import type { PreviewWorktreeManager } from '../worktrees/manager/preview-worktree-manager.js';
import type { SessionWorktreeManager } from '../worktrees/manager.js';
import type { BridgeHeartbeatController } from './heartbeat/controller.js';
import type { BridgeIdentifiedPayload } from './bridge-identified-types.js';

export function createBridgeMessageDeps(params: {
  getWs: () => WebSocket | null;
  log: LogFn;
  acpManager: AcpManager;
  sessionWorktreeManager: SessionWorktreeManager;
  previewWorktreeManager: PreviewWorktreeManager;
  onBridgeIdentified: (msg: BridgeIdentifiedPayload) => void;
  bridgeHeartbeat: BridgeHeartbeatController;
  sendLocalSkillsReport: () => void;
  reportAutoDetectedAgents: () => Promise<void>;
  warmupAgentCapabilitiesOnConnect: () => Promise<void>;
  previewEnvironmentManager: PreviewEnvironmentManager;
  updateFirehoseProxyPorts?: (proxyPorts: number[]) => void;
  e2ee: CliE2eeRuntime | undefined;
  cloudApiBaseUrl: string;
  getCloudAccessToken: () => string;
}): MessageHandlerDeps {
  const {
    getWs,
    log,
    acpManager,
    sessionWorktreeManager,
    previewWorktreeManager,
    onBridgeIdentified,
    bridgeHeartbeat,
    sendLocalSkillsReport,
    reportAutoDetectedAgents,
    warmupAgentCapabilitiesOnConnect,
    previewEnvironmentManager,
    updateFirehoseProxyPorts,
    e2ee,
    cloudApiBaseUrl,
    getCloudAccessToken,
  } = params;

  return {
    getWs,
    log,
    acpManager,
    sessionWorktreeManager,
    previewWorktreeManager,
    onBridgeIdentified,
    onBridgeHeartbeatAck: (seq: number) => {
      bridgeHeartbeat.onAck(seq);
    },
    sendLocalSkillsReport,
    reportAutoDetectedAgents,
    warmupAgentCapabilitiesOnConnect,
    previewEnvironmentManager,
    updateFirehoseProxyPorts,
    e2ee,
    cloudApiBaseUrl,
    getCloudAccessToken,
  };
}
